import RequestService from '../../../services/request-service';

/**
 * Live Channel Online Request Service
 */
export default class LiveStreamingAllRequestService extends RequestService {
	/**
	 * Class constructor method
	 */
	constructor() {
		super();
		this.endpoint = this.$config.endpoints.liveStreamingAll;
		this.method = 'get';

		this.headers = null;
	}
}
